(function () {
  'use strict';

  /* Heights live in cm (theme settings > Sizes); shoppers see inches, to the nearest half: 52 → "20½" */
  function inches(cm) {
    var halves = Math.round((cm / 2.54) * 2);
    return Math.floor(halves / 2) + (halves % 2 ? '½' : '');
  }

  /* Product page: variant picker, price, availability */
  function initProduct(root) {
    var variantsEl = root.querySelector('[data-variants-json]');
    var picker = root.querySelector('[data-variant-picker]');
    if (!variantsEl) return;

    var variants = JSON.parse(variantsEl.textContent);
    var strings = JSON.parse(root.querySelector('[data-product-strings]').textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var pricePlainEl = root.querySelector('[data-price-plain]');
    var titleEl = root.querySelector('[data-variant-title]');
    var addButtons = root.querySelectorAll('[data-add-button]');
    var gallery = initGallery(root);
    var galleryEl = root.querySelector('[data-gallery]');
    var colourPosition = galleryEl ? Number(galleryEl.getAttribute('data-colour-position')) : 0;
    var form = root.querySelector('[data-product-form]');
    var ageGroup = picker ? picker.querySelector('[data-age-group]') : null;
    var colourGroup = picker ? picker.querySelector('[data-colour-group]') : null;
    var ageNudge = root.querySelector('[data-age-nudge]');

    /* No age or colour is picked for the shopper (sections/main-product.liquid), so Add to bag waits
       for one: the age first, then the colour */
    function unpickedGroup() {
      return [ageGroup, colourGroup].find(function (group) {
        return group && !group.querySelector('input[type="radio"]:checked');
      });
    }

    function selectedColour(options) {
      return colourPosition ? options[colourPosition - 1] : '';
    }

    function selectedOptions() {
      var checked = picker.querySelectorAll('input[type="radio"]:checked');
      var options = [];
      checked.forEach(function (input) {
        options[Number(input.dataset.optionPosition) - 1] = input.value;
      });
      return options;
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === options[index];
        });
      });
    }

    var lowStockEl = root.querySelector('[data-low-stock]');

    /* Cross out every option value that has no available variant with the other current choices */
    function markAvailability(options) {
      if (!picker) return;
      picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var position = Number(input.dataset.optionPosition) - 1;
        var available = variants.some(function (variant) {
          if (!variant.available || variant.options[position] !== input.value) return false;
          // a choice not made yet (the age, before they pick) matches any value
          return variant.options.every(function (value, index) {
            return index === position || options[index] === undefined || value === options[index];
          });
        });
        var label = picker.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        label.classList.toggle('is-unavailable', !available);
        var soldOutText = label.querySelector('[data-sold-out-text]');
        if (soldOutText) soldOutText.hidden = available;
      });
    }

    /* Order on WhatsApp: the message names what they picked, so the order needs no back-and-forth.
       Before an age is picked it asks for help choosing instead. */
    var orderLink = root.querySelector('[data-order-whatsapp]');
    function setOrderMessage() {
      if (!orderLink) return;
      var lines = ['Hi! I would like to order:', orderLink.getAttribute('data-title')];
      var url = orderLink.getAttribute('data-url');
      var picked = [];
      var missingAge = false;
      if (picker) {
        picker.querySelectorAll('.variant-picker__group').forEach(function (group) {
          var name = group.querySelector('legend strong');
          var value = group.querySelector('[data-option-label]');
          if (!name || !value) return;
          var checked = group.querySelector('input[type="radio"]:checked');
          if (!checked) {
            if (group === ageGroup) missingAge = true;
            return;
          }
          picked.push(name.textContent.replace(':', '').trim() + ': ' + value.textContent.trim());
        });
      }
      if (missingAge) {
        lines.push('Can you help me pick the age?');
      } else {
        var variant = findVariant(selectedOptions());
        var qtyInput = root.querySelector('[data-quantity] input');
        var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        if (picked.length) lines.push(picked.join(' · '));
        if (variant) {
          var priceText = String(variant.price).replace(/<[^>]*>/g, '').trim();
          lines.push('Quantity: ' + qty + ' · ' + priceText);
          url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variant.id;
        }
      }
      lines.push(url);
      orderLink.href = 'https://wa.me/' + orderLink.getAttribute('data-number') + '?text=' + encodeURIComponent(lines.join('\n'));
    }
    if (orderLink) {
      // also right before it opens, so a quantity typed a moment ago is included
      orderLink.addEventListener('click', setOrderMessage);
    }

    /* "One size for 6 to 12 months" under the ages while an overlapping age is picked */
    var oneSizeEl = root.querySelector('[data-one-size]');
    function setOneSize() {
      if (!oneSizeEl || !ageGroup) return;
      var checked = ageGroup.querySelector('input[type="radio"]:checked');
      var clean = function (text) { return String(text).replace(/-/g, '–').trim().toLowerCase(); };
      var hidden = (oneSizeEl.getAttribute('data-one-size-ages') || '').split(',').map(clean);
      var show = Boolean(checked) && hidden.indexOf(clean(checked.value)) !== -1;
      oneSizeEl.hidden = !show;
      if (show) oneSizeEl.querySelector('[data-one-size-text]').textContent = 'One size for ' + checked.value.trim().replace(/[–-]/g, ' to ');
    }

    function setLowStock(variant) {
      if (!lowStockEl) return;
      var count = variant && variant.available ? variant.low_stock : 0;
      lowStockEl.hidden = !count;
      if (count) lowStockEl.querySelector('[data-low-stock-count]').textContent = count;
    }

    /* "5–6 years is sold out" with a WhatsApp button shows for a sold-out age, with the age in the message */
    var notifyEl = root.querySelector('[data-notify-me]');
    var anyAvailable = variants.some(function (variant) { return variant.available; });
    /* An age picked before the colour, with every colour of it sold out: its notify box shows straight away */
    function soldOutAge() {
      var ageInput = ageGroup && colourGroup ? ageGroup.querySelector('input[type="radio"]:checked') : null;
      if (!ageInput) return '';
      var index = Number(ageInput.dataset.optionPosition) - 1;
      var ofAge = variants.filter(function (variant) { return variant.options[index] === ageInput.value; });
      return ofAge.length && !ofAge.some(function (variant) { return variant.available; }) ? ageInput.value : '';
    }

    function setNotify(variant, age) {
      if (!notifyEl) return;
      var show = (Boolean(variant) && !variant.available) || Boolean(age);
      notifyEl.hidden = !show;
      if (!show) return;
      var title = notifyEl.querySelector('[data-notify-title]');
      var ageLabel = ageGroup ? ageGroup.querySelector('[data-option-label]') : null;
      if (title) {
        if (!anyAvailable) title.textContent = 'Sold out in every age';
        else if (ageLabel) title.textContent = ageLabel.textContent.trim() + ' is sold out';
        else title.textContent = 'This one is sold out';
      }
      var link = notifyEl.querySelector('a[data-notify-base]');
      if (link) link.href = link.dataset.notifyBase + encodeURIComponent(' For: ' + (variant ? variant.title : age));
    }

    /* Buy it now greys out with Add to bag for a sold-out age: Shopify only disables it on page load */
    function setSoldOut(soldOut) {
      if (!form) return;
      form.classList.toggle('product-form--sold-out', soldOut);
      var buyNow = form.querySelector('.shopify-payment-button__button');
      if (buyNow) {
        buyNow.disabled = soldOut;
        // removed rather than set to "false": Shopify's Buy it now does nothing while the attribute is there at all
        if (soldOut) buyNow.setAttribute('aria-disabled', 'true');
        else buyNow.removeAttribute('aria-disabled');
      }
    }

    function setButtons(label, disabled) {
      addButtons.forEach(function (button) {
        button.textContent = label;
        button.disabled = disabled;
      });
    }

    /* "Size: 4 y · 110" above the sizes: the chosen pill's data-display-label, else the plain value */
    function setOptionLabels(options) {
      options.forEach(function (value, index) {
        var label = root.querySelector('[data-option-label="' + (index + 1) + '"]');
        if (!label || value === undefined) return;
        var checked = picker.querySelector('input[data-option-position="' + (index + 1) + '"]:checked');
        var pill = checked ? picker.querySelector('label[for="' + checked.id + '"]') : null;
        label.textContent = (pill && pill.getAttribute('data-display-label')) || value;
      });
    }

    function update() {
      var options = selectedOptions();
      setOptionLabels(options);
      setOneSize();
      setOrderMessage();

      markAvailability(options);

      var unpicked = unpickedGroup();
      if (unpicked) {
        // one choice made before the other: show that colour's photos (or all), keep asking
        // (unless every colour of the picked age is sold out: then say so and offer the notify box)
        var soldAge = unpicked === colourGroup ? soldOutAge() : '';
        setNotify(null, soldAge);
        setSoldOut(Boolean(soldAge));
        if (soldAge) setButtons(strings.soldOut, true);
        else setButtons(unpicked === ageGroup ? strings.chooseAge : strings.chooseColour, false);
        gallery.showColour(selectedColour(options), null, true);
        // the age is picked now, so its "pick an age" message goes
        if (ageNudge && unpicked !== ageGroup) ageNudge.hidden = true;
        return;
      }
      if (form) form.classList.remove('product-form--needs-choice');
      if (ageNudge) ageNudge.hidden = true;

      var variant = findVariant(options);
      setLowStock(variant);
      setNotify(variant);
      setSoldOut(!variant || !variant.available);
      if (!variant) {
        setButtons(strings.unavailable, true);
        return;
      }

      idInput.value = variant.id;
      if (priceEl) {
        priceEl.innerHTML = variant.price + (variant.compare_at_price ? ' <s>' + variant.compare_at_price + '</s>' : '');
      }
      if (pricePlainEl) pricePlainEl.innerHTML = variant.price;
      if (titleEl) titleEl.textContent = variant.title;
      setButtons(variant.available ? strings.add : strings.soldOut, !variant.available);

      gallery.showColour(selectedColour(options), variant.media_id, true);

      // quick view sits over another page, so it leaves that page's address alone
      if (root.hasAttribute('data-quick-view-root')) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function askForChoice(unpicked) {
      if (ageNudge && unpicked === ageGroup) ageNudge.hidden = false;
      unpicked.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = unpicked.querySelector('input[type="radio"]');
      if (first) first.focus({ preventScroll: true });
    }

    /* Buy it now stays in place but greyed before an age is picked (tapping it asks for the age) and
       for a sold-out age (Shopify can leave it enabled on page load) */
    if (form) {
      form.addEventListener('click', function (event) {
        if (!event.target.closest('.shopify-payment-button')) return;
        var unpicked = unpickedGroup();
        if (!unpicked && !form.classList.contains('product-form--sold-out')) return;
        event.preventDefault();
        event.stopPropagation();
        if (unpicked) askForChoice(unpicked);
      }, true);
    }

    /* Add to bag (or the sticky bar's) before an age or colour: ask for it instead of adding the first */
    if (form) {
      form.addEventListener('submit', function (event) {
        var unpicked = unpickedGroup();
        if (!unpicked) return;
        event.preventDefault();
        event.stopPropagation();
        askForChoice(unpicked);
      });
    }

    if (picker) {
      picker.addEventListener('change', update);
      markAvailability(selectedOptions());
      setOptionLabels(selectedOptions());

      var startVariant = findVariant(selectedOptions());
      setNotify(startVariant);
      gallery.showColour(selectedColour(selectedOptions()), startVariant ? startVariant.media_id : null, false);
    }
  }

  /* Product photos: show the selected colour's photos, and a full-screen zoom viewer */
  function initGallery(root) {
    var gallery = root.querySelector('[data-gallery]');
    if (!gallery) return { showColour: function () {} };

    function items() {
      return Array.prototype.slice.call(gallery.querySelectorAll('[data-media-id]'));
    }

    function visibleItems() {
      return items().filter(function (item) {
        return !item.hidden;
      });
    }

    /* colour: the selected colour name, mediaId: the variant's own photo (shown first) */
    function showColour(colour, mediaId, scroll) {
      colour = String(colour || '').toLowerCase();
      items().forEach(function (item) {
        var itemColour = item.getAttribute('data-media-colour');
        item.hidden = !!(itemColour && colour && itemColour !== colour);
        item.classList.remove('product__media--main');
      });

      var featured = mediaId ? gallery.querySelector('[data-media-id="' + mediaId + '"]') : null;
      if (featured && !featured.hidden) gallery.insertBefore(featured, gallery.firstChild);

      var visible = visibleItems();
      if (visible.length) visible[0].classList.add('product__media--main');
      gallery.classList.toggle('product__gallery--single', visible.length === 1);
      if (scroll) gallery.scrollLeft = 0;
      buildNav();
      // a colour picked (not the page opening): its photos are now first, so load the ones it slides to
      if (scroll) loadAhead(gallery);
    }

    /* One photo at a time: arrows, "1 / 5", dots (mobile) and thumbnails (desktop), rebuilt from the
       photos that are showing whenever the colour changes */
    var photos = root.querySelector('[data-photos]');
    var countEl = photos && photos.querySelector('[data-gallery-count]');
    var dotsEl = photos && photos.querySelector('[data-gallery-dots]');
    var thumbsEl = photos && photos.querySelector('[data-gallery-thumbs]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = -1;

    function slideOffset(item) {
      return item.offsetLeft - (parseFloat(window.getComputedStyle(gallery).paddingLeft) || 0);
    }

    function activeIndex() {
      var best = 0;
      var bestDistance = Infinity;
      visibleItems().forEach(function (item, i) {
        var distance = Math.abs(slideOffset(item) - gallery.scrollLeft);
        if (distance < bestDistance) {
          best = i;
          bestDistance = distance;
        }
      });
      return best;
    }

    function goTo(i) {
      var list = visibleItems();
      if (!list.length) return;
      i = (i + list.length) % list.length;
      gallery.scrollTo({ left: slideOffset(list[i]), behavior: reduceMotion ? 'auto' : 'smooth' });
      setActive(i);
    }

    function setActive(i) {
      var total = visibleItems().length;
      current = i;
      if (countEl) countEl.textContent = total > 1 ? i + 1 + ' / ' + total : '';
      if (dotsEl) {
        Array.prototype.forEach.call(dotsEl.children, function (dot, n) {
          dot.classList.toggle('is-active', n === i);
        });
      }
      if (thumbsEl) {
        Array.prototype.forEach.call(thumbsEl.children, function (thumb, n) {
          thumb.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
      }
    }

    function buildNav() {
      if (!photos) return;
      var list = visibleItems();
      photos.classList.toggle('product__photos--many', list.length > 1);
      if (dotsEl) dotsEl.innerHTML = '';
      if (thumbsEl) thumbsEl.innerHTML = '';
      list.forEach(function (item, i) {
        if (dotsEl) dotsEl.appendChild(document.createElement('span'));
        if (!thumbsEl) return;
        var thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.setAttribute('aria-label', 'Show photo ' + (i + 1) + ' of ' + list.length);
        var img = document.createElement('img');
        img.src = item.getAttribute('data-thumb-src');
        img.alt = '';
        // tiny (200 px), so they come with the page instead of showing as white boxes first
        img.loading = 'eager';
        thumb.appendChild(img);
        thumb.addEventListener('click', function () {
          goTo(i);
        });
        thumbsEl.appendChild(thumb);
      });
      setActive(activeIndex());
    }

    if (photos) {
      var prevButton = photos.querySelector('[data-gallery-prev]');
      var nextButton = photos.querySelector('[data-gallery-next]');
      if (prevButton) {
        prevButton.addEventListener('click', function () {
          goTo(current - 1);
        });
      }
      if (nextButton) {
        nextButton.addEventListener('click', function () {
          goTo(current + 1);
        });
      }
      var ticking = false;
      gallery.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            var i = activeIndex();
            if (i !== current) setActive(i);
          });
        },
        { passive: true }
      );
      buildNav();
    }

    /* Zoom viewer */
    var zoom = root.querySelector('[data-zoom]');
    if (zoom) {
      var stage = zoom.querySelector('[data-zoom-stage]');
      var hint = zoom.querySelector('[data-zoom-hint]');
      var prev = zoom.querySelector('[data-zoom-prev]');
      var next = zoom.querySelector('[data-zoom-next]');
      var image = document.createElement('img');
      image.className = 'zoom__image';
      image.alt = '';
      image.decoding = 'async';
      stage.appendChild(image);

      var list = [];
      var index = 0;
      var lastFocus = null;

      function setZoomed(zoomed, event) {
        zoom.classList.toggle('is-zoomed', zoomed);
        hint.hidden = zoomed;
        if (!zoomed) return;
        // keep the spot that was tapped under the finger
        var rect = image.getBoundingClientRect();
        var x = event ? (event.clientX - rect.left) / rect.width : 0.5;
        var y = event ? (event.clientY - rect.top) / rect.height : 0.5;
        window.requestAnimationFrame(function () {
          stage.scrollLeft = x * stage.scrollWidth - stage.clientWidth / 2;
          stage.scrollTop = y * stage.scrollHeight - stage.clientHeight / 2;
        });
      }

      function show(newIndex) {
        index = (newIndex + list.length) % list.length;
        setZoomed(false);
        image.src = list[index].getAttribute('data-zoom-src');
        image.alt = list[index].getAttribute('data-zoom-alt') || '';
        prev.hidden = next.hidden = list.length < 2;
      }

      function closeZoom() {
        zoom.hidden = true;
        document.documentElement.classList.remove('has-open-drawer');
        image.removeAttribute('src');
        if (lastFocus) lastFocus.focus();
      }

      gallery.addEventListener('click', function (event) {
        var button = event.target.closest('[data-zoom-open]');
        if (!button) return;
        list = visibleItems()
          .map(function (item) {
            return item.querySelector('[data-zoom-open]');
          })
          .filter(Boolean);
        lastFocus = button;
        zoom.hidden = false;
        document.documentElement.classList.add('has-open-drawer');
        show(Math.max(list.indexOf(button), 0));
        stage.focus();
      });

      image.addEventListener('click', function (event) {
        setZoomed(!zoom.classList.contains('is-zoomed'), event);
      });
      stage.addEventListener('click', function (event) {
        if (event.target === stage) closeZoom();
      });
      zoom.querySelector('[data-zoom-close]').addEventListener('click', closeZoom);
      prev.addEventListener('click', function () {
        show(index - 1);
      });
      next.addEventListener('click', function () {
        show(index + 1);
      });
      document.addEventListener('keydown', function (event) {
        if (zoom.hidden) return;
        if (event.key === 'Escape') closeZoom();
        if (event.key === 'ArrowLeft') show(index - 1);
        if (event.key === 'ArrowRight') show(index + 1);
      });
    }

    return { showColour: showColour };
  }

  /* Price filter: digits only (no minus sign, so the browser's own warning never shows), and From/To
     swap if From is the higher one */
  function initPriceFilter(range) {
    var min = range.querySelector('[data-price-min]');
    var max = range.querySelector('[data-price-max]');
    [min, max].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        var digits = input.value.replace(/[^0-9]/g, '');
        if (digits !== input.value) input.value = digits;
      });
    });
    var form = range.closest('form');
    if (!form || !min || !max) return;
    form.addEventListener('submit', function () {
      var low = parseInt(min.value, 10);
      var high = parseInt(max.value, 10);
      if (!isNaN(low) && !isNaN(high) && low > high) {
        min.value = high;
        max.value = low;
      }
    }, true);
  }

  /* Tables wider than the screen (size charts): "Swipe for more" and a fade until scrolled to the end.
     Re-checked on resize, so it also works for the size sheet, which is hidden when the page loads */
  /* Silent looping videos (the Video section) load nothing until they come near the screen, then play,
     and pause again once scrolled away. Shoppers who ask for less motion get a play button instead.
     A video marked data-video-sound first tries to play with sound; browsers block that until the shopper
     has tapped the page (iPhones always), so it then plays muted with a "Tap for sound" button, which
     starts it again from the beginning with sound. Muting by hand sticks while scrolling */
  function initAutoplayVideos() {
    var videos = document.querySelectorAll('[data-autoplay-video]');
    if (!videos.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      videos.forEach(function (video) { video.controls = true; });
      return;
    }
    function soundButton(video) {
      return video.hasAttribute('data-video-sound') && video.parentNode.querySelector('[data-video-sound-button]');
    }
    function showSound(video) {
      var button = soundButton(video);
      if (!button) return;
      button.hidden = false;
      button.querySelector('[data-video-sound-off]').hidden = !video.muted;
      button.querySelector('[data-video-sound-on]').hidden = video.muted;
    }
    function playMuted(video) {
      video.muted = true;
      var started = video.play();
      if (started && started.then) started.then(function () { showSound(video); }, function () {});
    }
    function play(video) {
      if (!soundButton(video) || video.dataset.userMuted) {
        playMuted(video);
        return;
      }
      video.muted = false;
      var started = video.play();
      if (!started || !started.then) return;
      started.then(function () { showSound(video); }, function (error) {
        if (error && error.name === 'NotAllowedError') playMuted(video);
      });
    }
    videos.forEach(function (video) {
      var button = soundButton(video);
      if (!button) return;
      button.addEventListener('click', function () {
        if (video.muted) {
          delete video.dataset.userMuted;
          video.muted = false;
          video.currentTime = 0;
          var started = video.play();
          if (started && started.catch) started.catch(function () {});
        } else {
          video.dataset.userMuted = 'true';
          video.muted = true;
        }
        showSound(video);
      });
    });
    if (!('IntersectionObserver' in window)) {
      videos.forEach(play);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) play(entry.target);
        else entry.target.pause();
      });
    }, { rootMargin: '200px 0px' });
    videos.forEach(function (video) { observer.observe(video); });
  }

  /* Hero carousel (sections/hero.liquid photo blocks): the next photo every few seconds; dots and a swipe
     move it by hand. Pauses while the pointer is over it, the tab is hidden or after a tap on a dot, and
     stays on the first photo for shoppers who ask for less motion */
  function initHeroCarousel(box) {
    var slides = Array.prototype.slice.call(box.querySelectorAll('[data-hero-slide]'));
    var dots = Array.prototype.slice.call(box.querySelectorAll('[data-hero-dot]'));
    if (slides.length < 2) return;
    var interval = Number(box.getAttribute('data-interval')) || 4000;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer = null;
    var hovering = false;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var on = i === current;
        slide.classList.toggle('is-active', on);
        if (on) {
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('tabindex');
          var img = slide.querySelector('img');
          if (img && img.loading === 'lazy') img.loading = 'eager';
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('tabindex', '-1');
        }
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        if (i === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      // the one after next starts loading now, so it is ready when its turn comes
      var after = slides[(current + 1) % slides.length].querySelector('img');
      if (after && after.loading === 'lazy') after.loading = 'eager';
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    function start() {
      if (still || hovering || document.hidden) return;
      stop();
      timer = setInterval(function () { show(current + 1); }, interval);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        start();
      });
    });

    box.addEventListener('mouseenter', function () {
      hovering = true;
      stop();
    });
    box.addEventListener('mouseleave', function () {
      hovering = false;
      start();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    var startX = null;
    var startY = 0;
    box.addEventListener('touchstart', function (event) {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    box.addEventListener('touchend', function (event) {
      if (startX === null) return;
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      startX = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      show(current + (dx < 0 ? 1 : -1));
      start();
    }, { passive: true });
    start();
  }

  /* Review cards (sections/customer-quotes.liquid): the track scrolls sideways on its own, by swipe or
     trackpad; the arrows move it one card, the dots jump to a card, and both follow the scroll position */
  function initQuotes(section) {
    var track = section.querySelector('[data-quotes-track]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-quotes-card]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-quotes-dot]'));
    var prev = section.querySelector('[data-quotes-prev]');
    var next = section.querySelector('[data-quotes-next]');
    if (!track || cards.length < 2) return;

    function offset(card) {
      return card.offsetLeft - cards[0].offsetLeft;
    }

    function current() {
      var end = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= end - 2) return cards.length - 1;
      var nearest = 0;
      cards.forEach(function (card, i) {
        if (Math.abs(offset(card) - track.scrollLeft) < Math.abs(offset(cards[nearest]) - track.scrollLeft)) nearest = i;
      });
      return nearest;
    }

    function update() {
      var index = current();
      var end = track.scrollWidth - track.clientWidth;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= end - 2;
    }

    function go(index) {
      var card = cards[Math.max(0, Math.min(cards.length - 1, index))];
      track.scrollTo({ left: offset(card) });
    }

    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); });
    });
    var pending = null;
    track.addEventListener('scroll', function () {
      if (pending) return;
      pending = window.requestAnimationFrame(function () {
        pending = null;
        update();
      });
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Infinite scroll on collection and search pages: the next page of cards loads as the shopper nears the
     end of the grid, in place of the page numbers (which stay for anyone without JavaScript). Only the
     section is fetched (section_id). A "Show more" button stays as the fallback and after an error. */
  function initInfiniteScroll(grid) {
    var section = grid.closest('.shopify-section');
    var nav = section && section.querySelector('.pagination');
    if (!nav) return;
    var sectionId = section.id.replace('shopify-section-', '');
    // the page numbers never show with the script on, whichever page they landed on
    nav.hidden = true;
    var nextLink = nav.querySelector('.next a');
    var prevLink = nav.querySelector('.prev a');

    // landed on a later page (an old link, say): a button above the grid brings the earlier styles in on top
    if (prevLink) {
      var prev = prevLink.href;
      var earlier = document.createElement('div');
      earlier.className = 'infinite-scroll infinite-scroll--earlier';
      earlier.innerHTML = '<a class="btn btn--outline infinite-scroll__more" href="' + prev + '">Show earlier styles</a>';
      var earlierButton = earlier.querySelector('a');
      grid.parentNode.insertBefore(earlier, grid);
      earlierButton.addEventListener('click', function (event) {
        event.preventDefault();
        if (earlier.classList.contains('is-loading')) return;
        earlier.classList.add('is-loading');
        earlierButton.textContent = 'Loading…';
        var url = new URL(prev, window.location.href);
        url.searchParams.set('section_id', sectionId);
        fetch(url.toString())
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cards = doc.querySelector('[data-infinite-grid]');
            var first = grid.firstElementChild;
            if (cards) {
              Array.prototype.slice.call(cards.children).forEach(function (card) {
                grid.insertBefore(card, first);
              });
            }
            var link = doc.querySelector('.pagination .prev a');
            prev = link ? new URL(link.getAttribute('href'), window.location.href).toString() : null;
            earlier.classList.remove('is-loading');
            earlierButton.textContent = 'Show earlier styles';
            if (prev) earlierButton.href = prev;
            else earlier.remove();
          })
          .catch(function () {
            earlier.classList.remove('is-loading');
            earlierButton.textContent = 'Show earlier styles';
          });
      });
    }

    if (!nextLink) return;
    var next = nextLink.href;
    var loading = false;

    var box = document.createElement('div');
    box.className = 'infinite-scroll';
    box.innerHTML = '<p class="infinite-scroll__status" aria-live="polite"></p>' +
      '<a class="btn btn--outline infinite-scroll__more" href="' + next + '">Show more</a>';
    var status = box.querySelector('.infinite-scroll__status');
    var more = box.querySelector('.infinite-scroll__more');
    nav.parentNode.insertBefore(box, nav);

    var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) load();
    }, { rootMargin: '800px 0px' }) : null;

    function finish() {
      if (observer) observer.disconnect();
      more.remove();
      status.textContent = "That's everything";
      box.classList.add('is-done');
    }

    function load() {
      if (loading || !next) return;
      loading = true;
      box.classList.add('is-loading');
      status.textContent = 'Loading more styles…';
      var url = new URL(next, window.location.href);
      url.searchParams.set('section_id', sectionId);
      fetch(url.toString())
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-infinite-grid]');
          if (newGrid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (card) {
              grid.appendChild(card);
            });
          }
          var link = doc.querySelector('.pagination .next a');
          next = link ? new URL(link.getAttribute('href'), window.location.href).toString() : null;
          loading = false;
          box.classList.remove('is-loading');
          status.textContent = '';
          if (next) {
            more.href = next;
            // still near the end (a tall screen, or 12 cards that end above the fold): look again, which
            // loads the next batch straight away; the observer only speaks up when that changes
            if (observer) {
              observer.unobserve(box);
              observer.observe(box);
            }
          } else {
            finish();
          }
        })
        .catch(function () {
          loading = false;
          box.classList.remove('is-loading');
          status.textContent = "Couldn't load more. Tap to try again.";
          if (observer) observer.disconnect();
        });
    }

    more.addEventListener('click', function (event) {
      event.preventDefault();
      if (observer) observer.observe(box);
      load();
    });
    if (observer) observer.observe(box);
  }

  function initScrollHints() {
    document.querySelectorAll('[data-scroll-hint]').forEach(function (hint) {
      var area = hint.querySelector('[data-scroll-hint-area]');
      if (!area) return;
      function check() {
        var scrollable = area.scrollWidth > area.clientWidth + 2;
        hint.classList.toggle('is-scrollable', scrollable);
        hint.classList.toggle('is-at-end', scrollable && area.scrollLeft + area.clientWidth >= area.scrollWidth - 2);
      }
      area.addEventListener('scroll', check, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(check).observe(area);
      window.addEventListener('resize', check);
      check();
    });
  }

  /*
    Photos in a sideways strip (product photos, quick view, "look closer", close-ups, bag suggestions)
    are lazy, so pages open fast, and the browser only fetches one as it slides in, so it showed as an
    empty box first. Here the next two photos past the ones showing load whenever a strip comes near
    the screen or moves, so each one is there before it slides in.
  */
  var PHOTOS_AHEAD = 2;

  function warmPhoto(img) {
    if (img.loading === 'lazy') img.loading = 'eager';
  }

  function loadAhead(strip) {
    var edge = strip.getBoundingClientRect().right;
    var imgs = Array.prototype.filter.call(strip.querySelectorAll('img'), function (img) {
      return !img.closest('[hidden]');
    });
    var last = -1;
    imgs.forEach(function (img, i) {
      var box = img.getBoundingClientRect();
      if (box.width && box.left < edge) last = i;
    });
    imgs.slice(last + 1, last + 1 + PHOTOS_AHEAD).forEach(warmPhoto);
  }

  function stripOf(img) {
    for (var el = img.parentElement; el && el !== document.body; el = el.parentElement) {
      var overflow = window.getComputedStyle(el).overflowX;
      if ((overflow === 'auto' || overflow === 'scroll') && el.scrollWidth > el.clientWidth + 1) return el;
    }
    return null;
  }

  function initPhotoStrips() {
    var strips = [];
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      var strip = stripOf(img);
      if (strip && strips.indexOf(strip) === -1) strips.push(strip);
    });
    if (!('IntersectionObserver' in window)) return strips.forEach(loadAhead);
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadAhead(entry.target);
        });
      },
      { rootMargin: '300px 0px' }
    );
    strips.forEach(function (strip) {
      observer.observe(strip);
    });
  }

  // A swipe or an arrow moves a strip (scroll doesn't bubble, so this listens on the way down)
  var aheadQueued = [];
  document.addEventListener(
    'scroll',
    function (event) {
      var strip = event.target;
      if (!strip || !strip.querySelector || aheadQueued.indexOf(strip) !== -1) return;
      if (!strip.querySelector('img[loading="lazy"]')) return;
      aheadQueued.push(strip);
      window.requestAnimationFrame(function () {
        aheadQueued.splice(aheadQueued.indexOf(strip), 1);
        loadAhead(strip);
      });
    },
    { capture: true, passive: true }
  );

  // The phone menu's photos and the bag's suggestions are hidden until opened: they load quietly once
  // the page has finished, so they are there when it opens (the menu only exists below 990px)
  function warmHiddenPhotos() {
    var phone = window.matchMedia('(max-width: 989px)').matches;
    document.querySelectorAll((phone ? '.mobile-nav__tile-image, ' : '') + '[data-cart-drawer] img').forEach(warmPhoto);
  }

  // After the page's own photos, so the first screen is never slower
  function afterPageLoad(fn) {
    function idle() {
      if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 3000 });
      else window.setTimeout(fn, 1500);
    }
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
  }

  /* Quantity steppers. The box takes digits only and is never below 1: typing "-1" or "0" (the form
     skips the browser's own min check) snaps back to 1 when the box is left, and again before adding */
  function initQuantity(wrapper) {
    var input = wrapper.querySelector('input');
    function clamp() {
      input.value = Math.max(1, parseInt(input.value, 10) || 1);
    }
    wrapper.querySelector('[data-quantity-minus]').addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    wrapper.querySelector('[data-quantity-plus]').addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
    input.addEventListener('input', function () {
      var digits = input.value.replace(/[^0-9]/g, '');
      if (digits !== input.value) input.value = digits;
    });
    input.addEventListener('change', clamp);
    input.addEventListener('blur', clamp);
    var form = input.form;
    // capture, so it runs before the Add to bag handler reads the form
    if (form) form.addEventListener('submit', clamp, true);
  }

  /* The bag page's quantity boxes: digits only (0 removes the item), never negative */
  document.addEventListener('input', function (event) {
    var box = event.target;
    if (!box.matches || !box.matches('input[name="updates[]"]')) return;
    var digits = box.value.replace(/[^0-9]/g, '');
    if (digits !== box.value) box.value = digits;
  });

  /* Sticky add-to-bag bar: show once the main button scrolls out of view */
  function initStickyBar(root) {
    var bar = root.querySelector('[data-sticky-atc]');
    var mainButton = root.querySelector('.product-form__submit');
    if (!bar || !mainButton) return;

    var scheduled = false;
    function update() {
      scheduled = false;
      // Do not cover the gallery or repeat the main purchase controls.
      var visible = mainButton.getBoundingClientRect().bottom <= 0;
      bar.classList.toggle('is-visible', visible);
      bar.inert = !visible;
    }
    function scheduleUpdate() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    }

    update();
    // Scroll also handles jumps that skip the button entirely (e.g. anchor links).
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(scheduleUpdate).observe(mainButton);
    }
  }

  /* Product recommendations are rendered by Shopify on a second request */
  function initRecommendations(container) {
    fetch(container.dataset.recommendationsUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations-url]');
        if (fresh && fresh.innerHTML.trim().length) container.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* Collection: sorting submits straight away */
  function initSort(select) {
    select.addEventListener('change', function () {
      select.form.submit();
    });
  }

  /* Slide-out bag: add with the Cart API, then swap in a freshly rendered drawer */
  /* The welcome code goes on the bag by itself once something is in it (snippets/welcome-code-reminder),
     unless the shopper took it off this visit. Tried once per page, so a code Shopify turns down
     doesn't loop. Runs on every page: the bag page has no drawer, so there it reloads to show the total. */
  var welcomeCodeDrawer = null;
  var codeRemovedKey = 'minimodo:code-removed';
  var codeTried = false;
  function codeRemoved() {
    try { return window.sessionStorage.getItem(codeRemovedKey) === '1'; } catch (error) { return false; }
  }
  function setDiscount(code) {
    var routes = (window.MiniModo && window.MiniModo.routes) || {};
    return fetch((routes.cartUpdate || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code, sections: 'cart-drawer', sections_url: window.location.pathname })
    }).then(function (response) {
      return response.json();
    });
  }
  function afterDiscount(element, data) {
    var inDrawer = welcomeCodeDrawer && welcomeCodeDrawer.drawer.contains(element);
    if (!inDrawer) return window.location.reload();
    if (data.sections && data.sections['cart-drawer']) welcomeCodeDrawer.render(data.sections['cart-drawer']);
  }
  function applyWelcomeCode() {
    var reminder = document.querySelector('[data-code-reminder][data-applied="false"]');
    if (!reminder || codeTried || codeRemoved()) return;
    codeTried = true;
    setDiscount(reminder.getAttribute('data-code'))
      .then(function (data) {
        afterDiscount(reminder, data);
      })
      .catch(function () {});
  }
  function initWelcomeCode() {
    document.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-code-remove]');
      if (!remove) return;
      try { window.sessionStorage.setItem(codeRemovedKey, '1'); } catch (error) {}
      remove.disabled = true;
      setDiscount('')
        .then(function (data) {
          afterDiscount(remove, data);
        })
        .catch(function () {
          window.location.reload();
        });
    });
    // the bag page, or a bag that already has items when the page loads
    applyWelcomeCode();
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var routes = (window.MiniModo && window.MiniModo.routes) || null;
    if (!drawer || !routes) return;

    var panel = drawer.querySelector('[data-cart-panel]');
    var lastFocus = null;

    function setCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = !count;
      });
    }

    function renderFrom(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-inner]');
      var current = drawer.querySelector('[data-cart-drawer-inner]');
      if (!fresh || !current) return;
      current.innerHTML = fresh.innerHTML;
      current.dataset.itemCount = fresh.dataset.itemCount;
      setCount(Number(fresh.dataset.itemCount) || 0);
      applyWelcomeCode();
    }

    // the welcome code (initWelcomeCode) re-renders the drawer through this when it changes the bag
    welcomeCodeDrawer = { drawer: drawer, render: renderFrom };

    function refresh() {
      return fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function (response) {
          return response.json();
        })
        .then(function (sections) {
          if (sections['cart-drawer']) renderFrom(sections['cart-drawer']);
        })
        .catch(function () {});
    }

    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      // force a layout pass so the slide-in transition runs from the closed position
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.documentElement.classList.add('has-open-drawer');
      panel.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('has-open-drawer');
      window.setTimeout(function () {
        drawer.hidden = true;
      }, 250);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function showError(target, message) {
      if (!target) return;
      target.textContent = message;
      target.hidden = !message;
    }

    /* Shopify's stock errors ("Only 1 item was added to your cart due to availability", "You can't add
       more ... to the cart") in our words */
    function friendlyError(data, fallback) {
      var message = (data && (data.description || data.message)) || '';
      // no stock counts for shoppers for now, so neither message says how many there are
      if (/maximum quantity|already in your cart/i.test(message)) {
        return "That's all we have in this age, and it's in your bag.";
      }
      if (/availab|can.t add more|sold out|in stock/i.test(message)) {
        return "That's all we have in this age, and it's in your bag.";
      }
      return message.replace(/\bcart\b/gi, 'bag') || fallback;
    }

    /* Add to bag */
    /* One listener for every add form, so cards that load later (recommendations) work too */
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('form[action$="/cart/add"]')) return;
      {
        if (event.submitter && event.submitter.name === 'checkout') return;
        event.preventDefault();

        var quickAdd = form.hasAttribute('data-quick-add');
        var errorEl = form.querySelector('[data-add-error]');
        // the product page and quick view each have their own buttons and labels
        var scope = form.closest('[data-product]') || document;
        var buttons = quickAdd ? form.querySelectorAll('button[type="submit"]:not([disabled])') : scope.querySelectorAll('[data-add-button]');
        var labels = [];
        var stringsEl = scope.querySelector('[data-product-strings]');
        var adding = stringsEl && !quickAdd ? JSON.parse(stringsEl.textContent).adding : null;
        buttons.forEach(function (button, index) {
          labels[index] = button.textContent;
          button.disabled = true;
          if (adding) button.textContent = adding;
        });
        showError(errorEl, '');

        var body = new FormData(form);
        // size buttons on product cards carry the variant id themselves
        if (event.submitter && event.submitter.name === 'id') body.set('id', event.submitter.value);
        body.append('sections', 'cart-drawer');
        body.append('sections_url', window.location.pathname);

        fetch(routes.cartAdd + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok) {
              showError(errorEl, friendlyError(result.data, 'Sorry, that could not be added.'));
              return;
            }
            // added from quick view: close it so the bag shows
            var quickView = form.closest('[data-quick-view-dialog]');
            if (quickView && quickView.open) quickView.close();
            if (result.data.sections && result.data.sections['cart-drawer']) {
              renderFrom(result.data.sections['cart-drawer']);
              open();
            } else {
              return refresh().then(open);
            }
          })
          .then(function () {
            var details = form.closest('[data-quick-add-details]');
            if (details) details.removeAttribute('open');
          })
          .catch(function () {
            // network problem: fall back to the normal form post
            form.submit();
          })
          .then(function () {
            buttons.forEach(function (button, index) {
              button.disabled = false;
              button.textContent = labels[index];
            });
          });
      }
    });

    /* Open, close, change quantity, remove */
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-cart-toggle]');
      if (toggle) {
        event.preventDefault();
        // open straight away with what we have, then bring it up to date
        open();
        refresh();
        return;
      }

      if (event.target.closest('[data-cart-close]')) {
        close();
        return;
      }

      var change = event.target.closest('[data-line-change]');
      if (!change || !drawer.contains(change)) return;

      var line = change.closest('[data-line-key]');
      line.classList.add('is-updating');

      fetch(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: line.dataset.lineKey,
          quantity: Number(change.dataset.lineChange),
          sections: 'cart-drawer',
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (result.ok && result.data.sections && result.data.sections['cart-drawer']) {
            renderFrom(result.data.sections['cart-drawer']);
          } else {
            line.classList.remove('is-updating');
            showError(drawer.querySelector('[data-cart-error]'), friendlyError(result.data, 'Sorry, that could not be updated.'));
          }
        })
        .catch(function () {
          window.location.href = routes.cart;
        });
    });

    document.addEventListener('keydown', function (event) {
      if (drawer.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key !== 'Tab') return;

      // keep keyboard focus inside the open drawer
      var focusable = panel.querySelectorAll('a[href], button:not([disabled]), input, textarea, select');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  /* Countdown sections: numbers tick down to the date set in the section (Pakistan time) */
  function initCountdown(section) {
    var end = new Date(section.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) return;

    var clock = section.querySelector('[data-countdown-clock]');
    var done = section.querySelector('[data-countdown-done]');
    var parts = {
      days: section.querySelector('[data-countdown-days]'),
      hours: section.querySelector('[data-countdown-hours]'),
      minutes: section.querySelector('[data-countdown-minutes]'),
      seconds: section.querySelector('[data-countdown-seconds]')
    };
    var timer;

    function pad(number) {
      return number < 10 ? '0' + number : String(number);
    }

    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) {
        clearInterval(timer);
        clock.hidden = true;
        if (section.getAttribute('data-countdown-after') === 'message') {
          done.hidden = false;
        } else if (!(window.Shopify && window.Shopify.designMode)) {
          section.hidden = true;
        }
        return;
      }
      parts.days.textContent = pad(Math.floor(left / 86400));
      parts.hours.textContent = pad(Math.floor((left % 86400) / 3600));
      parts.minutes.textContent = pad(Math.floor((left % 3600) / 60));
      parts.seconds.textContent = pad(left % 60);
      clock.hidden = false;
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  /* The ages a shopper can pick, in months, from the youngest to the oldest age in the size table.
     Used by the size finder (a select) and the size sheet (buttons). */
  function ageChoices(minAge, maxAge) {
    var ages = [
      [1.5, '0–3', 'months'],
      [4.5, '3–6', 'months'],
      [7.5, '6–9', 'months'],
      [10.5, '9–12', 'months'],
      [15, '12–18', 'months'],
      [21, '18–24', 'months']
    ];
    for (var year = 2; year * 12 < maxAge; year++) ages.push([year * 12 + 6, String(year), 'years']);
    return ages
      .filter(function (age) {
        return age[0] < maxAge && age[0] >= minAge;
      })
      .map(function (age) {
        return { months: age[0], range: age[1], unit: age[2], text: age[1].replace('–', ' to ') + ' ' + age[2] };
      });
  }

  /* Size finder: suggests a size from a height or an age, and can select it on the product page */
  function initSizeFinder(root) {
    var dataEl = root.querySelector('[data-size-finder-data]');
    var form = root.querySelector('[data-size-finder-form]');
    if (!dataEl || !form) return;

    var data = JSON.parse(dataEl.textContent);
    var sizes = String(data.sizes || '')
      .split('\n')
      .map(function (line) {
        var cells = line.split('|').map(function (cell) {
          return cell.trim();
        });
        return {
          name: cells[0],
          heightFrom: parseFloat(cells[1]),
          heightTo: parseFloat(cells[2]),
          ageFrom: parseFloat(cells[3]),
          ageTo: parseFloat(cells[4]),
          ageLabel: cells[5] || ''
        };
      })
      .filter(function (size) {
        return size.name && !isNaN(size.heightFrom) && !isNaN(size.heightTo);
      });
    if (!sizes.length) return;

    var heightInput = root.querySelector('[data-size-finder-height]');
    var ageSelect = root.querySelector('[data-size-finder-age]');
    var result = root.querySelector('[data-size-finder-result]');
    var label = root.querySelector('[data-size-finder-label]');
    var sizeText = root.querySelector('[data-size-finder-size]');
    var note = root.querySelector('[data-size-finder-note]');
    var selectButton = root.querySelector('[data-size-finder-select]');
    var whatsapp = root.querySelector('[data-size-finder-whatsapp]');

    /* Age choices, in months, from the youngest to the oldest age in the list */
    var maxAge = 0;
    var minAge = Infinity;
    sizes.forEach(function (size) {
      if (!isNaN(size.ageTo) && size.ageTo > maxAge) maxAge = size.ageTo;
      if (!isNaN(size.ageFrom) && size.ageFrom < minAge) minAge = size.ageFrom;
    });
    ageChoices(minAge, maxAge).forEach(function (age) {
      var option = document.createElement('option');
      option.value = age.months;
      option.textContent = age.text;
      ageSelect.appendChild(option);
    });
    if (ageSelect.options.length < 2) {
      ageSelect.closest('.size-finder__field').hidden = true;
      root.querySelector('.size-finder__or').hidden = true;
    }

    var minHeight = Math.min.apply(null, sizes.map(function (size) { return size.heightFrom; }));
    var maxHeight = Math.max.apply(null, sizes.map(function (size) { return size.heightTo; }));

    /* Every size that fits, narrowest first (then the smaller one), since bands can overlap */
    function fitting(test, by) {
      return sizes.filter(test).sort(function (a, b) {
        var widthA = by === 'age' ? a.ageTo - a.ageFrom : a.heightTo - a.heightFrom;
        var widthB = by === 'age' ? b.ageTo - b.ageFrom : b.heightTo - b.heightFrom;
        return widthA - widthB || a.heightTo - b.heightTo;
      });
    }

    /* On a product page, the narrowest size this product comes in; anywhere else, the narrowest size */
    function pick(candidates) {
      for (var i = 0; i < candidates.length; i++) {
        if (findPickerInput(candidates[i])) return candidates[i];
      }
      return candidates[0] || null;
    }

    function normalise(text) {
      return String(text).toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    /* The matching age pill on a product page, if there is one. A product's value can be the age
       ("4–5 years") or an old size number ("110"). */
    function findPickerInput(match) {
      var inputs = document.querySelectorAll('[data-variant-picker] input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        var value = normalise(inputs[i].value);
        if (value === normalise(match.name) || (match.ageLabel && value === normalise(match.ageLabel))) return inputs[i];
      }
      return null;
    }

    function show(match, messages, isProblem) {
      // Shoppers see the age and the height, never the size number
      var shown = match ? match.ageLabel || match.name : '';
      label.textContent = isProblem ? '' : 'Pick';
      label.hidden = isProblem;
      sizeText.textContent = shown;
      sizeText.hidden = !match;
      if (match) messages.unshift('It fits children ' + inches(match.heightFrom) + '–' + inches(match.heightTo) + '\u00a0inches tall.');
      note.textContent = messages.join(' ');
      note.hidden = !messages.length;
      if (whatsapp) whatsapp.hidden = !isProblem;

      var input = match ? findPickerInput(match) : null;
      selectButton.hidden = !input;
      if (input) {
        var label_ = document.querySelector('label[for="' + input.id + '"]');
        var soldOut = label_ && label_.classList.contains('is-unavailable');
        selectButton.textContent = soldOut ? shown + ' is sold out' : 'Select ' + shown;
        selectButton.disabled = !!soldOut;
        selectButton.onclick = function () {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          var picker = document.querySelector('[data-variant-picker]');
          if (picker) picker.scrollIntoView({ block: 'center' });
        };
      }
      result.hidden = false;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      // typed in inches, compared in cm like the size table
      var height = parseFloat(heightInput.value) * 2.54;
      var age = parseFloat(ageSelect.value);
      var match = null;
      var messages = [];

      var candidates;
      if (!isNaN(height)) {
        if (height < minHeight) return show(null, [data.too_small], true);
        if (height > maxHeight) return show(null, [data.too_big], true);
        candidates = fitting(function (size) {
          // A boundary height belongs to the smaller size: 73 cm is 6–9 months, not 9–12
          return (height > size.heightFrom || size.heightFrom === minHeight) && height <= size.heightTo;
        }, 'height');
        match = pick(candidates);
        if (match.heightTo < maxHeight && height > match.heightTo - 3) messages.push(data.between);
      } else if (!isNaN(age)) {
        if (age < minAge) return show(null, [data.too_small], true);
        candidates = fitting(function (size) {
          return age >= size.ageFrom && age < size.ageTo;
        }, 'age');
        match = pick(candidates);
        if (!match) return show(null, [data.too_big], true);
        messages.push(data.age_note);
      } else {
        heightInput.focus();
        return;
      }

      // Bands overlap (6–12 months next to 6–9 and 9–12), so name the wider band that also fits
      var also = candidates.filter(function (size) {
        return size !== match && size.ageLabel && !findPickerInput(size);
      });
      if (also.length && !document.querySelector('[data-variant-picker]')) {
        messages.push('Pieces sold as ' + also.map(function (size) { return size.ageLabel; }).join(' or ') + ' fit too.');
      }
      show(match, messages, false);
    });

    /* One answer at a time: typing a height clears the age, and the other way round */
    heightInput.addEventListener('input', function () {
      if (heightInput.value) ageSelect.value = '';
    });
    ageSelect.addEventListener('change', function () {
      if (ageSelect.value) heightInput.value = '';
    });
  }

  /* Size sheet ("find their size" over the page, snippets/size-sheet.liquid). The shopper taps an age
     and it names the age to pick. On a product page it prefers the ages the piece comes in, and its
     button selects that age in the picker. Opens from anything with data-size-sheet-open. */
  function initSizeSheet() {
    var dialog = document.querySelector('[data-size-sheet]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var rows = Array.prototype.map.call(dialog.querySelectorAll('[data-size-row]'), function (row) {
      return {
        row: row,
        name: row.getAttribute('data-name'),
        label: row.getAttribute('data-label'),
        heightFrom: parseFloat(row.getAttribute('data-height-from')),
        heightTo: parseFloat(row.getAttribute('data-height-to')),
        ageFrom: parseFloat(row.getAttribute('data-age-from')),
        ageTo: parseFloat(row.getAttribute('data-age-to')),
        url: row.getAttribute('data-url'),
        sold: row.hasAttribute('data-sold')
      };
    });
    if (!rows.length) return;

    var forProduct = dialog.classList.contains('size-sheet--product');
    // a piece whose ages are not in the size table: help like on any other page, with every age
    if (forProduct && !rows.some(function (size) { return size.sold; })) {
      forProduct = false;
      dialog.classList.remove('size-sheet--product');
      var toggle = dialog.querySelector('[data-size-sheet-all]');
      if (toggle) toggle.hidden = true;
      dialog.querySelector('[data-size-sheet-chart-title]').textContent = 'All our ages';
    }
    var chips = dialog.querySelector('[data-size-sheet-chips]');
    var result = dialog.querySelector('[data-size-sheet-result]');
    var message = dialog.querySelector('[data-size-sheet-message]');
    var selectButton = dialog.querySelector('[data-size-sheet-select]');
    var link = dialog.querySelector('[data-size-sheet-link]');
    var allToggle = dialog.querySelector('[data-size-sheet-all]');
    var chartTitle = dialog.querySelector('[data-size-sheet-chart-title]');
    var lastFocus = null;
    var chosen = null;

    function normalise(text) {
      return String(text).toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    /* "6–9, 9–12 and 18–24 months", or "6–9 months and 2–3 years" when the units differ */
    function listAges(labels) {
      var units = labels.map(function (label) {
        return label.split(' ').slice(1).join(' ');
      });
      var sameUnit = units.every(function (unit) {
        return unit === units[0];
      });
      var parts = labels.map(function (label, i) {
        return sameUnit && i < labels.length - 1 ? label.split(' ')[0] : label;
      });
      if (parts.length < 2) return parts.join('');
      return parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1];
    }

    /* The age's radio in the product picker. A value can be the age ("4–5 years") or an old size number */
    function pickerInput(size) {
      var inputs = document.querySelectorAll('[data-variant-picker] input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        var value = normalise(inputs[i].value);
        if (value === normalise(size.name) || value === normalise(size.label)) return inputs[i];
      }
      return null;
    }

    function showAll(all) {
      dialog.classList.toggle('is-showing-all', all);
      if (!allToggle) return;
      allToggle.setAttribute('aria-pressed', String(all));
      allToggle.textContent = all ? 'Only this piece' : 'Show all ages';
      chartTitle.textContent = all ? 'All our ages' : 'This piece comes in';
    }

    function heightText(size) {
      return isNaN(size.heightFrom) ? '' : ' It fits children ' + inches(size.heightFrom) + '–' + inches(size.heightTo) + ' inches tall.';
    }

    function choose(months) {
      // every size for this age, narrowest first, since bands overlap (6–12 months next to 6–9)
      var fits = rows
        .filter(function (size) {
          return months >= size.ageFrom && months < size.ageTo;
        })
        .sort(function (a, b) {
          return a.ageTo - a.ageFrom - (b.ageTo - b.ageFrom) || a.heightTo - b.heightTo;
        });
      if (!fits.length) return;
      var sold = fits.filter(function (size) {
        return size.sold;
      });
      var match = forProduct && sold.length ? sold[0] : fits[0];
      chosen = match;

      rows.forEach(function (size) {
        size.row.classList.toggle('is-match', size === match);
      });

      var strong = document.createElement('strong');
      message.textContent = '';
      selectButton.hidden = true;
      link.hidden = true;

      if (forProduct && !sold.length) {
        var comesIn = rows
          .filter(function (size) {
            return size.sold;
          })
          .map(function (size) {
            return size.label;
          });
        strong.textContent = 'This piece doesn’t come in ' + match.label + '.';
        message.appendChild(strong);
        if (comesIn.length) message.appendChild(document.createTextNode(' It comes in ' + listAges(comesIn) + '.'));
        result.classList.remove('is-good');
        if (match.url) {
          link.href = match.url;
          link.textContent = 'See everything for ' + match.label;
          link.hidden = false;
        }
      } else {
        strong.textContent = 'Pick ' + match.label + '.';
        message.appendChild(strong);
        var extra = heightText(match);
        if (!forProduct) {
          var also = fits.filter(function (size) {
            return size !== match;
          });
          if (also.length) {
            extra += ' Pieces sold as ' + also.map(function (size) { return size.label; }).join(' or ') + ' fit too.';
          }
        }
        message.appendChild(document.createTextNode(extra));
        result.classList.add('is-good');

        var input = forProduct ? pickerInput(match) : null;
        if (input) {
          var pill = document.querySelector('label[for="' + input.id + '"]');
          var soldOut = pill && pill.classList.contains('is-unavailable');
          selectButton.textContent = soldOut ? match.label + ' is sold out' : 'Select ' + match.label;
          selectButton.disabled = !!soldOut;
          selectButton.hidden = false;
        } else if (match.url) {
          link.href = match.url;
          link.textContent = 'Shop ' + match.label;
          link.hidden = false;
        }
      }
      result.hidden = false;
    }

    // the age buttons, built from the size table so they always match it
    var minAge = Infinity;
    var maxAge = 0;
    rows.forEach(function (size) {
      if (size.ageFrom < minAge) minAge = size.ageFrom;
      if (size.ageTo > maxAge) maxAge = size.ageTo;
    });
    ageChoices(minAge, maxAge).forEach(function (age, i) {
      var id = 'SizeSheetAge-' + i;
      var input = document.createElement('input');
      input.type = 'radio';
      input.name = 'size-sheet-age';
      input.id = id;
      input.value = age.months;
      input.className = 'visually-hidden';
      var label = document.createElement('label');
      label.className = 'size-sheet__chip';
      label.htmlFor = id;
      var range = document.createElement('span');
      range.className = 'size-sheet__chip-range';
      range.textContent = age.range;
      var unit = document.createElement('span');
      unit.className = 'size-sheet__chip-unit';
      unit.textContent = age.unit;
      label.appendChild(range);
      label.appendChild(unit);
      chips.appendChild(input);
      chips.appendChild(label);
    });
    chips.addEventListener('change', function (event) {
      choose(parseFloat(event.target.value));
    });

    selectButton.addEventListener('click', function () {
      var input = chosen ? pickerInput(chosen) : null;
      if (!input) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      lastFocus = input;
      close();
    });

    if (allToggle) {
      allToggle.addEventListener('click', function () {
        showAll(!dialog.classList.contains('is-showing-all'));
      });
    }

    function open() {
      lastFocus = document.activeElement;
      // the menu and the sheet should not both be open
      document.querySelectorAll('.mobile-nav[open]').forEach(function (menu) {
        menu.removeAttribute('open');
      });
      dialog.showModal();
      document.documentElement.classList.add('has-open-drawer');
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-size-sheet-open]');
      if (!opener) return;
      event.preventDefault();
      open();
    });

    // tidy up straight away rather than only on the close event, which some browsers send late
    function closed() {
      if (!document.documentElement.classList.contains('has-open-drawer')) return;
      document.documentElement.classList.remove('has-open-drawer');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function close() {
      dialog.close();
      closed();
    }

    // the close button and the dark area; Esc closes the dialog by itself and sends the close event
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-size-sheet-close]')) close();
    });
    dialog.addEventListener('close', closed);
  }

  /* Help sheet ("how can we help?", snippets/help-sheet.liquid): a list of questions, each opening its
     answer in the same sheet. Opens from anything with data-help-open (the Help tab, Need help?). */
  function initHelpSheet() {
    var dialog = document.querySelector('[data-help-sheet]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var title = dialog.querySelector('[data-help-title]');
    var sub = dialog.querySelector('[data-help-sub]');
    var back = dialog.querySelector('[data-help-back]');
    var whatsapp = dialog.querySelector('[data-help-whatsapp]');
    var whatsappText = dialog.querySelector('[data-help-whatsapp-text]');
    var whatsappBase = whatsapp ? whatsapp.getAttribute('href') : '';
    var menuTitle = title.textContent;
    var menuSub = sub.textContent;
    var lastFocus = null;

    function show(name, heading, line) {
      dialog.querySelectorAll('[data-help-screen]').forEach(function (screen) {
        screen.hidden = screen.getAttribute('data-help-screen') !== name;
      });
      title.textContent = heading || menuTitle;
      sub.textContent = line || menuSub;
      back.hidden = name === 'menu';
      dialog.setAttribute('data-screen', name);
      if (whatsapp) {
        whatsappText.textContent = whatsapp.getAttribute('data-text-' + name) || whatsapp.getAttribute('data-text-menu');
        var message = whatsapp.getAttribute('data-message-' + name);
        whatsapp.href = message ? whatsappBase + '?text=' + encodeURIComponent(message) : whatsappBase;
      }
      dialog.scrollTop = 0;
    }

    function open() {
      lastFocus = document.activeElement;
      // the menu and the sheet should not both be open
      document.querySelectorAll('.mobile-nav[open]').forEach(function (menu) {
        menu.removeAttribute('open');
      });
      show('menu');
      dialog.showModal();
      document.documentElement.classList.add('has-open-drawer');
      document.querySelectorAll('[data-help-open]').forEach(function (opener) {
        opener.setAttribute('aria-expanded', 'true');
      });
    }

    // tidy up straight away rather than only on the close event, which some browsers send late
    function closed() {
      document.querySelectorAll('[data-help-open]').forEach(function (opener) {
        opener.setAttribute('aria-expanded', 'false');
      });
      if (!document.documentElement.classList.contains('has-open-drawer')) return;
      document.documentElement.classList.remove('has-open-drawer');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function close() {
      dialog.close();
      closed();
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-help-open]')) return;
      event.preventDefault();
      if (dialog.open) close();
      else open();
    });

    // the close buttons and the dark area; Esc closes the dialog by itself and sends the close event
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-help-close]')) return close();
      var row = event.target.closest('[data-help-go]');
      if (row) {
        event.preventDefault();
        show(row.getAttribute('data-help-go'), row.getAttribute('data-help-heading'), row.getAttribute('data-help-heading-sub'));
        back.focus();
      }
    });
    dialog.addEventListener('close', closed);
    back.addEventListener('click', function () {
      show('menu');
      var first = dialog.querySelector('[data-help-go]');
      if (first) first.focus();
    });

    /* Find their size: the height against the size sheet's rows (theme settings > Sizes) */
    var sizeForm = dialog.querySelector('[data-help-size-form]');
    var heightInput = dialog.querySelector('[data-help-height]');
    var result = dialog.querySelector('[data-help-size-result]');
    var message = dialog.querySelector('[data-help-size-message]');
    var selectButton = dialog.querySelector('[data-help-size-select]');
    var link = dialog.querySelector('[data-help-size-link]');
    var rows = Array.prototype.map.call(document.querySelectorAll('[data-size-sheet] [data-size-row]'), function (row) {
      return {
        name: row.getAttribute('data-name'),
        label: row.getAttribute('data-label'),
        heightFrom: parseFloat(row.getAttribute('data-height-from')),
        heightTo: parseFloat(row.getAttribute('data-height-to')),
        url: row.getAttribute('data-url'),
        sold: row.hasAttribute('data-sold')
      };
    }).filter(function (size) {
      return !isNaN(size.heightFrom) && !isNaN(size.heightTo);
    });
    var forProduct = rows.some(function (size) {
      return size.sold;
    });
    var chosen = null;

    function normalise(text) {
      return String(text).toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    function pickerInput(size) {
      var inputs = document.querySelectorAll('[data-variant-picker] input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        var value = normalise(inputs[i].value);
        if (value === normalise(size.name) || value === normalise(size.label)) return inputs[i];
      }
      return null;
    }

    // the stock answer's row for this age: its "Last one", "2 left" or "Sold out", and its Tell me link
    function stockRow(size) {
      return dialog.querySelector('[data-help-stock-age="' + size.label.replace(/"/g, '') + '"]');
    }

    function stockFor(size) {
      var row = stockRow(size);
      var status = row ? row.querySelector('.help-sheet__stock-status') : null;
      return status ? status.textContent.trim() : '';
    }

    function say(strong, rest, good) {
      message.textContent = '';
      var bold = document.createElement('strong');
      bold.textContent = strong;
      message.appendChild(bold);
      if (rest) message.appendChild(document.createTextNode(' ' + rest));
      result.classList.toggle('is-good', !!good);
      result.hidden = false;
    }

    function answer() {
      var typed = parseFloat(heightInput.value);
      selectButton.hidden = true;
      link.hidden = true;
      link.removeAttribute('target');
      chosen = null;
      if (isNaN(typed) || !rows.length) {
        result.hidden = true;
        return;
      }
      var height = typed * 2.54;
      var minHeight = Math.min.apply(null, rows.map(function (size) { return size.heightFrom; }));
      var maxHeight = Math.max.apply(null, rows.map(function (size) { return size.heightTo; }));
      if (height < minHeight) return say('Smaller than our smallest age.', 'Pick ' + rows[0].label + ', or ask us on WhatsApp.');
      if (height > maxHeight) return say('Taller than our biggest age.', 'Ask us on WhatsApp and we will check the measurements for you.');

      // every age that fits, narrowest first, since bands overlap (6–12 months next to 6–9);
      // a boundary height belongs to the smaller age, like the size finder
      var fits = rows
        .filter(function (size) {
          return (height > size.heightFrom || size.heightFrom === minHeight) && height <= size.heightTo;
        })
        .sort(function (a, b) {
          return a.heightTo - a.heightFrom - (b.heightTo - b.heightFrom) || a.heightTo - b.heightTo;
        });
      if (!fits.length) return say('We couldn’t match that height.', 'Pick their age instead, or ask us on WhatsApp.');
      var sold = fits.filter(function (size) {
        return size.sold;
      });
      var match = forProduct && sold.length ? sold[0] : fits[0];
      var fitsText = 'It fits children ' + inches(match.heightFrom) + ' to ' + inches(match.heightTo) + ' inches tall.';

      if (forProduct && !sold.length) {
        var comesIn = rows
          .filter(function (size) {
            return size.sold;
          })
          .map(function (size) {
            return size.label;
          });
        var list = comesIn.length > 1 ? comesIn.slice(0, -1).join(', ') + ' and ' + comesIn[comesIn.length - 1] : comesIn.join('');
        say('They need ' + match.label + '.', 'This piece doesn’t come in it' + (list ? '; it comes in ' + list + '.' : '.'));
        if (match.url) {
          link.href = match.url;
          link.textContent = 'See everything for ' + match.label;
          link.hidden = false;
        }
        return;
      }

      var stock = forProduct ? stockFor(match) : '';
      if (stock === 'Sold out') {
        say('They need ' + match.label + '.', 'It’s sold out in that age. We can WhatsApp you when it’s back.');
        var notify = stockRow(match).querySelector('.help-sheet__notify');
        if (notify) {
          link.href = notify.href;
          link.target = '_blank';
          link.rel = 'noopener';
          link.textContent = 'Tell me when it’s back';
          link.hidden = false;
        }
        return;
      }
      say('Pick ' + match.label + '.', fitsText + (stock && stock !== 'In stock' ? ' ' + stock + (stock === 'Last one' ? ' left.' : '.') : ''), true);
      var input = forProduct ? pickerInput(match) : null;
      if (input) {
        chosen = input;
        selectButton.textContent = 'Select ' + match.label;
        selectButton.hidden = false;
      } else if (match.url) {
        link.href = match.url;
        link.textContent = 'Shop ' + match.label;
        link.hidden = false;
      }
    }

    if (sizeForm) {
      sizeForm.addEventListener('submit', function (event) {
        event.preventDefault();
        answer();
      });
      heightInput.addEventListener('input', answer);
      sizeForm.querySelectorAll('[data-help-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          var now = parseFloat(heightInput.value);
          if (isNaN(now)) now = parseFloat(heightInput.placeholder) || 40;
          else now += parseFloat(button.getAttribute('data-help-step'));
          heightInput.value = Math.min(60, Math.max(15, now));
          answer();
        });
      });
      selectButton.addEventListener('click', function () {
        if (!chosen) return;
        chosen.checked = true;
        chosen.dispatchEvent(new Event('change', { bubbles: true }));
        lastFocus = chosen;
        close();
        var picker = document.querySelector('[data-variant-picker]');
        if (picker) picker.scrollIntoView({ block: 'center' });
      });
      // "Pick their age instead" opens the size sheet (it has data-size-sheet-open); this one closes first
      var ages = dialog.querySelector('[data-help-ages]');
      if (ages && document.querySelector('[data-size-sheet]')) {
        ages.addEventListener('click', function () {
          lastFocus = null;
          close();
        });
      }
    }

    /* Track my order: the track page looks the order up (initTrack). The details go through
       sessionStorage, so the phone number never sits in a URL. */
    var trackForm = dialog.querySelector('[data-help-track-form]');
    if (trackForm) {
      trackForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var order = dialog.querySelector('[data-help-track-order]').value.trim();
        var phone = dialog.querySelector('[data-help-track-phone]').value.trim();
        var error = dialog.querySelector('[data-help-track-error]');
        error.hidden = !!(order && phone);
        if (!order || !phone) return;
        var page = document.querySelector('[data-track-page]');
        if (page) {
          page.querySelector('[data-track-order]').value = order;
          page.querySelector('[data-track-phone]').value = phone;
          close();
          page.querySelector('[data-track-form]').requestSubmit();
          return;
        }
        try {
          sessionStorage.setItem('mm-track', JSON.stringify({ order: order, phone: phone }));
        } catch (e) {}
        window.location.href = trackForm.getAttribute('action');
      });
    }
  }

  /* Gift note in the bag: show the message box and save it on the cart as soon as it changes */
  function initGiftNote() {
    var routes = (window.MiniModo && window.MiniModo.routes) || null;
    if (!routes || !routes.cartUpdate) return;

    document.addEventListener('change', function (event) {
      var wrapper = event.target.closest('[data-gift-note]');
      if (!wrapper) return;

      var toggle = wrapper.querySelector('[data-gift-toggle]');
      var fields = wrapper.querySelector('[data-gift-fields]');
      var message = wrapper.querySelector('[data-gift-message]');

      fields.hidden = !toggle.checked;
      message.disabled = !toggle.checked;
      if (event.target === toggle && toggle.checked) message.focus();

      fetch(routes.cartUpdate + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            Gift: toggle.checked ? 'Yes' : '',
            'Gift message': toggle.checked ? message.value : ''
          }
        })
      }).catch(function () {});
    });
  }

  /* Mobile bottom bar: Shop opens the header menu and scrolls to the top */
  function initMobileBar() {
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var menu = document.querySelector('.mobile-nav');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var open = !menu.hasAttribute('open');
      if (open) {
        menu.setAttribute('open', '');
      } else {
        menu.removeAttribute('open');
      }
      toggle.setAttribute('aria-expanded', String(open));
    });
    menu.addEventListener('toggle', function () {
      toggle.setAttribute('aria-expanded', String(menu.hasAttribute('open')));
    });
  }

  /* Phone menu: opens at the top of the page as a sheet under the header, and holds the page still */
  function initMobileNav() {
    var menu = document.querySelector('.mobile-nav');
    var header = document.querySelector('.site-header');
    if (!menu || !header) return;

    menu.addEventListener('toggle', function () {
      var open = menu.hasAttribute('open');
      if (open) {
        window.scrollTo({ top: 0, behavior: 'instant' });
        var top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        document.documentElement.style.setProperty('--mobile-nav-top', top + 'px');
      }
      document.documentElement.classList.toggle('has-open-menu', open);
    });
  }

  /* Header dropdowns and product card size pickers close when clicking elsewhere */
  function initDropdowns() {
    document.addEventListener('click', function (event) {
      document.querySelectorAll('.site-nav__dropdown[open], [data-quick-add-details][open]').forEach(function (dropdown) {
        if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
      });
    });
  }

  /* Product page "Copy link", to paste the piece into a family chat */
  function initLinkCopy() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-copy-link]');
      if (!button || !navigator.clipboard) return;
      var text = button.querySelector('[data-copy-link-text]');
      var original = text.textContent;
      navigator.clipboard.writeText(button.getAttribute('data-copy-link')).then(function () {
        text.textContent = button.getAttribute('data-copied-text') || original;
        window.setTimeout(function () {
          text.textContent = original;
        }, 2500);
      });
    });
  }

  /* Copy a discount code. Delegated, so the copy of the code in the bag works after it re-renders */
  function initCodeCopy() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-code-copy]');
      if (!button) return;
      var label = button.querySelector('[data-copy-label]');
      var code = button.getAttribute('data-code-copy');

      function copied() {
        button.classList.add('is-copied');
        if (label) label.textContent = 'Copied';
        window.setTimeout(function () {
          button.classList.remove('is-copied');
          if (label) label.textContent = 'Copy';
        }, 2500);
      }

      // no clipboard access: select the code so it can be copied by hand
      function selectCode() {
        var text = button.parentNode.querySelector('[data-code-text]');
        if (!text || !window.getSelection) return;
        var range = document.createRange();
        range.selectNodeContents(text);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(copied, selectCode);
      } else {
        selectCode();
      }
    });
  }

  /* Welcome popup: opens once the shopper has looked around (the delay set in Theme settings on the first
     page of a visit, or 3 seconds into a second page), then stays away for the days set there */
  function initWelcomeOffer() {
    var root = document.querySelector('[data-welcome-offer]');
    if (!root) return;
    var dialog = root.querySelector('[data-welcome-dialog]');
    var tab = root.querySelector('[data-welcome-open]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var CLOSED_KEY = 'minimodo:welcome-closed';
    var TAB_KEY = 'minimodo:welcome-tab';
    var PAGES_KEY = 'minimodo:welcome-pages';
    var days = Number(root.dataset.days) || 14;
    var delay = (Number(root.dataset.delay) || 0) * 1000;

    // storage can be blocked (private mode, cookies off): the popup still works, it just forgets
    function read(store, key) {
      try {
        return window[store].getItem(key);
      } catch (error) {
        return null;
      }
    }

    function write(store, key, value) {
      try {
        window[store].setItem(key, value);
      } catch (error) {}
    }

    function remember() {
      write('localStorage', CLOSED_KEY, String(Date.now()));
      write('sessionStorage', TAB_KEY, '1');
    }

    function open() {
      if (tab) tab.hidden = true;
      dialog.showModal();
      document.documentElement.classList.add('has-open-drawer');
    }

    function tryOpen() {
      // wait while the bag, the photo zoom or the menu is open
      if (document.documentElement.classList.contains('has-open-drawer')) {
        window.setTimeout(tryOpen, 3000);
        return;
      }
      open();
    }

    // Close button, No thanks, Esc and the dark area all end up here
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('has-open-drawer');
      remember();
      if (tab) tab.hidden = false;
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-welcome-close]')) dialog.close();
    });

    root.querySelector('[data-welcome-apply]').addEventListener('click', remember);
    if (tab) tab.addEventListener('click', open);

    var closedAt = Number(read('localStorage', CLOSED_KEY)) || 0;
    var recentlyClosed = Date.now() - closedAt < days * 24 * 60 * 60 * 1000;

    if (!recentlyClosed) {
      var pages = (Number(read('sessionStorage', PAGES_KEY)) || 0) + 1;
      write('sessionStorage', PAGES_KEY, String(pages));
      window.setTimeout(tryOpen, pages > 1 ? Math.min(delay, 3000) : delay);
    } else if (tab && read('sessionStorage', TAB_KEY)) {
      tab.hidden = false;
    }
  }

  /* Quick view: a product card's eye button (or Choose options) opens the product in a window */
  function initQuickView() {
    var dialog = document.querySelector('[data-quick-view-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var body = dialog.querySelector('[data-quick-view-body]');
    var request = 0;
    var cache = {};
    var busy = null;

    function parse(html) {
      var content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-quick-view-root]');
      if (!content) throw new Error('no quick view');
      return content;
    }

    // Resolves once the photo is downloaded and ready to draw, or after `ms` if it is slow.
    function decoded(img, ms) {
      if (!img) return Promise.resolve();
      var ready = img.decode ? img.decode() : new Promise(function (resolve) { img.onload = img.onerror = resolve; });
      return Promise.race([
        ready.catch(function () {}),
        new Promise(function (resolve) { setTimeout(resolve, ms); })
      ]);
    }

    // Downloads the window's first photo, so it is there when the window opens instead of
    // popping in a second later. A slow photo holds the window back for 2.5 seconds at most.
    function firstPhoto(content) {
      var photo = content.querySelector('.quick-view__photo');
      if (!photo || !photo.getAttribute('src')) return Promise.resolve();
      var img = new Image();
      if (photo.getAttribute('sizes')) img.sizes = photo.getAttribute('sizes');
      if (photo.getAttribute('srcset')) img.srcset = photo.getAttribute('srcset');
      img.src = photo.getAttribute('src');
      return decoded(img, 2500);
    }

    // The window's HTML and first photo, fetched once per product (kept for 5 minutes): on hover,
    // so it is often ready by the click, or on the click itself.
    function prefetch(url) {
      var hit = cache[url];
      if (hit && Date.now() - hit.at < 300000) return hit.ready;
      var ready = fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=quick-view')
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (html) {
          return firstPhoto(parse(html)).then(function () { return html; });
        });
      cache[url] = { at: Date.now(), ready: ready };
      ready.catch(function () { delete cache[url]; });
      return ready;
    }

    function setBusy(trigger) {
      if (busy) {
        busy.classList.remove('is-busy');
        busy.removeAttribute('aria-busy');
      }
      busy = trigger;
      if (busy) {
        busy.classList.add('is-busy');
        busy.setAttribute('aria-busy', 'true');
      }
    }

    // The window opens once, with its photo, so nothing jumps: until then the button that opened it
    // shows a small spinner (or, for a product opened from inside the window, the window dims).
    function load(url, trigger) {
      var mine = ++request;
      if (dialog.open) dialog.classList.add('is-loading');
      else setBusy(trigger);
      return prefetch(url).then(function (html) {
        if (mine !== request) return;
        var content = parse(html);
        body.innerHTML = '';
        body.appendChild(content);
        initProduct(content);
        content.querySelectorAll('[data-quantity]').forEach(initQuantity);
        // its own copy of the photo comes from the browser cache by now: open once it is drawn
        return decoded(content.querySelector('.quick-view__photo'), 800).then(function () {
          if (mine !== request) return;
          dialog.classList.remove('is-loading');
          setBusy(null);
          if (!dialog.open) dialog.showModal();
          var strip = content.querySelector('[data-gallery]');
          if (strip) loadAhead(strip);
        });
      });
    }

    function nearby(event) {
      var trigger = event.target.closest && event.target.closest('[data-quick-view]');
      if (trigger) prefetch(trigger.getAttribute('data-quick-view')).catch(function () {});
    }
    document.addEventListener('pointerover', nearby);
    document.addEventListener('focusin', nearby);

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-quick-view]');
      if (!trigger) return;
      event.preventDefault();
      var url = trigger.getAttribute('data-quick-view');
      load(url, trigger).catch(function () {
        // could not load it here: go to the product page instead
        window.location.href = url;
      });
    });

    dialog.addEventListener('click', function (event) {
      // the close button, or a tap on the dark backdrop around the window
      if (event.target.closest('[data-quick-view-close]') || event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', function () {
      request++;
      body.innerHTML = '';
      dialog.classList.remove('is-loading');
      setBusy(null);
    });
  }

  /*
    Save for later: product handles kept in this browser (localStorage), newest first. No sign-in,
    so the list stays on this phone. Hearts are matched by handle, so a card, the product page and
    the saved page all agree. The saved page reads live price and stock from /products/<handle>.js.
  */
  function initSaved() {
    var KEY = 'minimodo:saved';
    var page = document.querySelector('[data-saved-page]');
    var toast = document.querySelector('[data-save-toast]');
    var toastTimer;
    var cache = {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // storage can be blocked (private mode): hearts still work for this page, they just forget
    function read() {
      try {
        var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
        return Array.isArray(list) ? list.filter(function (handle) { return typeof handle === 'string' && handle; }) : [];
      } catch (error) {
        return [];
      }
    }

    function write(list) {
      try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (error) {}
    }

    function sync() {
      var list = read();
      document.querySelectorAll('[data-save-toggle]').forEach(function (button) {
        var on = list.indexOf(button.getAttribute('data-save-toggle')) !== -1;
        var title = button.getAttribute('data-title') || 'this piece';
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        button.setAttribute('aria-label', on ? 'Remove ' + title + ' from saved' : 'Save ' + title + ' for later');
      });
      // text is only touched when it changes, or the MutationObserver below would keep firing
      document.querySelectorAll('[data-saved-count]').forEach(function (count) {
        if (count.textContent !== String(list.length)) count.textContent = list.length;
        count.hidden = list.length === 0;
      });
      document.querySelectorAll('[data-saved-link]').forEach(function (link) {
        link.hidden = list.length === 0;
        link.setAttribute('aria-label', 'Saved for later, ' + list.length);
      });
      document.querySelectorAll('[data-saved-sub]').forEach(function (sub) {
        var text = list.length === 0 ? 'Tap the heart on anything you like' : list.length === 1 ? '1 piece' : list.length + ' pieces';
        if (sub.textContent !== text) sub.textContent = text;
      });
    }

    function showToast(saved) {
      if (!toast) return;
      toast.querySelector('[data-save-toast-text]').textContent = saved ? 'Saved for later' : 'Removed from saved';
      toast.querySelector('[data-save-toast-link]').hidden = !saved;
      toast.hidden = false;
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () { toast.hidden = true; }, 3500);
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-save-toggle]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      var handle = button.getAttribute('data-save-toggle');
      var list = read();
      var index = list.indexOf(handle);
      var saved = index === -1;
      if (saved) list.unshift(handle);
      else list.splice(index, 1);
      write(list);
      sync();
      if (page) renderPage();
      else showToast(saved);
    });

    // another tab changed the list
    window.addEventListener('storage', function (event) {
      if (event.key !== KEY) return;
      sync();
      if (page) renderPage();
    });

    // cards that arrive later (recommendations, quick view, search) get the right hearts too
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        sync();
      });
    }).observe(document.body, { childList: true, subtree: true });

    sync();
    if (!page) return;

    var listEl = page.querySelector('[data-saved-list]');
    var rowTemplate = page.querySelector('[data-saved-row]');
    var countLine = page.querySelector('[data-saved-count-line]');
    var sendBox = page.querySelector('[data-saved-send]');
    var emptyBox = page.querySelector('[data-saved-empty]');
    var familyLink = page.querySelector('[data-saved-family]');
    var orderLink = page.querySelector('[data-saved-order]');
    var moneyFormat = page.getAttribute('data-money-format') || 'Rs.{{amount_no_decimals}}';
    var whatsapp = page.getAttribute('data-whatsapp');

    function money(cents) {
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
        var digits = key.indexOf('no_decimals') !== -1 ? 0 : 2;
        return (cents / 100).toFixed(digits).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      });
    }

    function fetchProduct(handle) {
      if (!cache[handle]) {
        cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
          .then(function (response) { return response.ok ? response.json() : null; })
          .catch(function () { return null; });
      }
      return cache[handle];
    }

    function ageIndex(product) {
      var found = -1;
      (product.options || []).forEach(function (option, i) {
        var name = String(option && option.name ? option.name : option).toLowerCase();
        if (name === 'age' || name === 'size') found = i;
      });
      return found;
    }

    // "Sold out in every age", or the ages left when only one or two are
    function stockNote(product) {
      if (!product.available) return 'Sold out in every age';
      var index = ageIndex(product);
      if (index === -1) return '';
      var all = [];
      var left = [];
      product.variants.forEach(function (variant) {
        var age = variant.options[index];
        if (all.indexOf(age) === -1) all.push(age);
        if (variant.available && left.indexOf(age) === -1) left.push(age);
      });
      if (left.length === all.length || left.length > 2) return '';
      return 'Only ' + left.join(' and ') + ' left';
    }

    function imageUrl(src) {
      if (!src) return '';
      return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=300';
    }

    function message(products, intro) {
      var origin = window.location.origin;
      return intro + '\n' + products.map(function (product, i) {
        return (i + 1) + '. ' + product.title + ', ' + money(product.price) + '\n' + origin + product.url;
      }).join('\n');
    }

    var renderRun = 0;
    function renderPage() {
      var run = ++renderRun;
      var handles = read();
      // first paint: the count straight away and a grey card per piece while prices and photos load
      if (!listEl.children.length) {
        countLine.textContent = handles.length === 0 ? 'Nothing here yet' : handles.length === 1 ? '1 piece' : handles.length + ' pieces';
        handles.slice(0, 6).forEach(function () {
          var ghost = document.createElement('div');
          ghost.className = 'saved-item saved-item--loading';
          ghost.setAttribute('aria-hidden', 'true');
          ghost.innerHTML = '<span class="saved-item__ghost-img"></span><span class="saved-item__ghost"><span></span><span></span><span></span></span>';
          listEl.appendChild(ghost);
        });
      }
      Promise.all(handles.map(fetchProduct)).then(function (results) {
        if (run !== renderRun) return;
        var products = results.filter(Boolean);
        // pieces that were deleted or hidden drop off the list
        if (products.length !== handles.length) {
          write(products.map(function (product) { return product.handle; }));
          sync();
        }

        listEl.textContent = '';
        products.forEach(function (product) {
          var row = rowTemplate.content.firstElementChild.cloneNode(true);
          row.querySelectorAll('[data-saved-url]').forEach(function (link) { link.href = product.url; });
          var img = row.querySelector('[data-saved-img]');
          if (product.featured_image) img.src = imageUrl(product.featured_image);
          else img.remove();
          row.querySelector('[data-saved-name]').textContent = product.title;
          var price = row.querySelector('[data-saved-price]');
          price.textContent = money(product.price);
          if (product.compare_at_price > product.price) {
            var was = document.createElement('s');
            was.textContent = money(product.compare_at_price);
            price.appendChild(document.createTextNode(' '));
            price.appendChild(was);
          }
          var note = stockNote(product);
          var stock = row.querySelector('[data-saved-stock]');
          stock.textContent = note;
          stock.hidden = !note;
          if (ageIndex(product) === -1) row.querySelector('[data-saved-choose]').textContent = 'See it';
          var remove = row.querySelector('[data-save-toggle]');
          remove.setAttribute('data-save-toggle', product.handle);
          remove.setAttribute('data-title', product.title);
          remove.setAttribute('aria-label', 'Remove ' + product.title + ' from saved');
          listEl.appendChild(row);
        });

        var count = products.length;
        countLine.textContent = count === 0 ? 'Nothing here yet' : count === 1 ? '1 piece' : count + ' pieces';
        sendBox.hidden = count === 0;
        emptyBox.hidden = count !== 0;
        if (count) {
          familyLink.href = 'https://wa.me/?text=' + encodeURIComponent(message(products, 'My saved pieces from Mini Modo:'));
          if (orderLink && whatsapp) {
            orderLink.href = 'https://wa.me/' + whatsapp + '?text=' + encodeURIComponent(message(products, 'Hi! I would like to order these from my saved list:'));
          }
        }
      });
    }

    renderPage();
  }

  document.querySelectorAll('[data-product]').forEach(function (root) {
    initProduct(root);
    initStickyBar(root);
  });
  document.querySelectorAll('[data-quantity]').forEach(initQuantity);
  document.querySelectorAll('[data-recommendations-url]').forEach(initRecommendations);
  document.querySelectorAll('[data-sort-select]').forEach(initSort);
  document.querySelectorAll('[data-infinite-grid]').forEach(initInfiniteScroll);
  document.querySelectorAll('[data-countdown]').forEach(initCountdown);
  document.querySelectorAll('[data-size-finder]').forEach(initSizeFinder);
  document.querySelectorAll('[data-hero-carousel]').forEach(initHeroCarousel);
  document.querySelectorAll('[data-quotes]').forEach(initQuotes);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-countdown]').forEach(initCountdown);
    event.target.querySelectorAll('[data-size-finder]').forEach(initSizeFinder);
    event.target.querySelectorAll('[data-quotes]').forEach(initQuotes);
  });
  // "track my order" page: asks the Order Ops lookup and shows status only (no name or address).
  // Send on WhatsApp (sections/main-send.liquid): swap the sealed token in #t= for Order Ops'
  // message, then offer WhatsApp Business (Android intent), regular WhatsApp and Copy. The token is
  // taken off the address first, and the message never goes back into it.
  function initSend() {
    var page = document.querySelector('[data-send-page]');
    if (!page) return;
    var q = function (sel) { return page.querySelector(sel); };
    var token = (location.hash.match(/(?:^#|&)t=([A-Za-z0-9_-]+)/) || [])[1] || '';
    if (location.hash) history.replaceState(null, '', location.pathname);
    var android = /Android/i.test(navigator.userAgent);
    var ios = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    var esc = function (v) {
      return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
    };
    var waFormat = function (t) { return esc(t).replace(/\*([^*\n]+)\*/g, '<b>$1</b>').replace(/(^|\s)_([^_\n]+)_/g, '$1<i>$2</i>'); };
    var note = function (text) { var n = q('[data-send-note]'); n.textContent = text; n.hidden = !text; };
    function fail(text) {
      q('[data-send-to]').textContent = 'Couldn\'t open this message';
      note(text);
    }
    if (!token) return fail('This link has no message in it. Open it again from Order Ops.');

    fetch(page.getAttribute('data-endpoint') + '?t=' + encodeURIComponent(token))
      .then(function (res) { return res.json().then(function (body) { return { ok: res.ok, body: body }; }); })
      .then(function (r) {
        if (!r.ok) return fail(r.body.error || 'Couldn\'t load the message.');
        var m = r.body;
        var text = m.text;
        var number = String(m.number || '');
        var params = [number ? 'phone=' + number : '', 'text=' + encodeURIComponent(text)].filter(Boolean).join('&');
        var waMe = 'https://wa.me/' + number + '?text=' + encodeURIComponent(text);
        var business = 'intent://send/?' + params + '#Intent;scheme=whatsapp;package=com.whatsapp.w4b;S.browser_fallback_url=' + encodeURIComponent(waMe) + ';end';
        q('[data-send-to]').textContent = number ? '+' + number.replace(/^(\d{2})(\d{3})(\d+)$/, '$1 $2 $3') : 'Pick the chat in WhatsApp';
        q('[data-send-bubble]').innerHTML = waFormat(text);
        q('[data-send-chat]').hidden = false;
        var biz = q('[data-send-business]');
        var reg = q('[data-send-regular]');
        if (android) {
          biz.href = business;
          reg.href = waMe;
        } else {
          biz.href = waMe;
          biz.textContent = 'Open WhatsApp';
          reg.hidden = true;
          if (ios && navigator.share) q('[data-send-share]').hidden = false;
        }
        q('[data-send-tip]').textContent = android
          ? 'Opens the Business app with the message typed in. Press Send there, then go back to Order Ops.'
          : ios ? 'An iPhone can\'t choose WhatsApp Business by link. If both apps are installed, use the share sheet and pick WhatsApp Business, or copy the message.'
          : 'Opens WhatsApp with the message typed in.';
        q('[data-send-actions]').hidden = false;

        q('[data-send-share]').addEventListener('click', function () {
          navigator.share({ text: text }).catch(function () {});
        });
        q('[data-send-copy]').addEventListener('click', function () {
          var box = q('[data-send-copy-box]');
          var done = function () { note('Copied. Paste it in the chat, then press Send.'); };
          var byHand = function () {
            box.value = text;
            box.hidden = false;
            box.focus();
            box.select();
            note('Hold on the text below, choose Select all, then Copy.');
          };
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, byHand);
          else byHand();
        });
      })
      .catch(function () { fail('Couldn\'t reach Order Ops. Check the connection and open the link again.'); });
  }

  function initTrack() {
    var page = document.querySelector('[data-track-page]');
    if (!page) return;
    var endpoint = page.getAttribute('data-endpoint');
    var form = page.querySelector('[data-track-form]');
    var result = page.querySelector('[data-track-result]');
    var message = page.querySelector('[data-track-message]');
    var submit = page.querySelector('[data-track-submit]');
    var orderInput = page.querySelector('[data-track-order]');
    var phoneInput = page.querySelector('[data-track-phone]');
    var cnInput = page.querySelector('[data-track-cn]');
    var q = function (sel) { return page.querySelector(sel); };

    function say(text) {
      message.textContent = text;
      message.hidden = !text;
    }

    function rupees(n) {
      return 'Rs ' + Math.round(n).toLocaleString('en-PK');
    }

    function day(iso) {
      if (!iso) return '';
      var d = new Date(iso);
      return isNaN(d) ? '' : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    }

    function show(data) {
      q('[data-track-order-line]').textContent = data.order
        ? 'Order ' + data.order.name + ' · ' + data.order.items + (data.order.items === 1 ? ' item' : ' items')
        : (data.cn ? 'Tracking ' + data.cn : '');
      q('[data-track-headline]').textContent = data.headline;
      q('[data-track-text]').textContent = data.message;

      var cash = q('[data-track-cash]');
      cash.hidden = !data.cashToPay;
      if (data.cashToPay) q('[data-track-cash-amount]').textContent = rupees(data.cashToPay);

      var steps = q('[data-track-steps]');
      steps.textContent = '';
      (data.steps || []).forEach(function (step, i) {
        var li = document.createElement('li');
        li.setAttribute('data-state', step.state);
        li.textContent = step.label;
        if (i === 0 && data.order && data.order.placed) li.textContent += ' · ' + day(data.order.placed);
        steps.appendChild(li);
      });
      steps.hidden = !(data.steps || []).length;

      var courier = q('[data-track-courier]');
      courier.hidden = !data.cn;
      if (data.cn) q('[data-track-cn-text]').textContent = data.cn;

      var history = q('[data-track-history]');
      history.textContent = '';
      (data.history || []).forEach(function (h) {
        var li = document.createElement('li');
        li.textContent = h.text + (h.at ? ' · ' + day(h.at) : '');
        history.appendChild(li);
      });
      q('[data-track-history-wrap]').hidden = !(data.history || []).length;

      form.hidden = true;
      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function lookup(body) {
      say('');
      submit.disabled = true;
      submit.textContent = 'Checking…';
      return fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) return say(r.data.error || 'Tracking is not available right now. Please message us on WhatsApp.');
          if (!r.data.found) {
            return say(body.cn
              ? "We couldn't find that tracking number. Check it and try again."
              : "We couldn't find an order with that number and phone. Use the phone number you ordered with.");
          }
          show(r.data);
        })
        .catch(function () { say('Tracking is not available right now. Please message us on WhatsApp.'); })
        .then(function () {
          submit.disabled = false;
          submit.textContent = 'Track';
        });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var cn = cnInput.value.trim();
      if (cn) return lookup({ cn: cn });
      if (!orderInput.value.trim() || !phoneInput.value.trim()) {
        return say('Enter your order number and phone number, or a PostEx tracking number.');
      }
      lookup({ order: orderInput.value.trim(), phone: phoneInput.value.trim() });
    });

    q('[data-track-again]').addEventListener('click', function () {
      result.hidden = true;
      form.hidden = false;
      orderInput.focus();
    });

    // The shipping email links here with ?cn=<tracking number>
    var fromLink = new URLSearchParams(window.location.search).get('cn');
    if (fromLink) {
      cnInput.value = fromLink;
      lookup({ cn: fromLink });
      return;
    }

    // The help sheet's "Track my order" (initHelpSheet) leaves the order number and phone here
    var fromHelp = null;
    try {
      fromHelp = JSON.parse(sessionStorage.getItem('mm-track') || 'null');
      sessionStorage.removeItem('mm-track');
    } catch (e) {}
    if (fromHelp && fromHelp.order && fromHelp.phone) {
      orderInput.value = fromHelp.order;
      phoneInput.value = fromHelp.phone;
      lookup({ order: fromHelp.order, phone: fromHelp.phone });
    }
  }

  initDropdowns();
  initMobileNav();
  initMobileBar();
  initCartDrawer();
  initScrollHints();
  initAutoplayVideos();
  document.querySelectorAll('[data-price-range]').forEach(initPriceFilter);
  initWelcomeCode();
  initGiftNote();
  initCodeCopy();
  initLinkCopy();
  initWelcomeOffer();
  initSizeSheet();
  initHelpSheet();
  initQuickView();
  initSaved();
  initTrack();
  initSend();
  afterPageLoad(initPhotoStrips);
  afterPageLoad(warmHiddenPhotos);
})();
